import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceEmployee } from 'app/models/employee.model';
import { EmployeeService } from 'app/services/employee.service';
import { SweetalertService } from 'app/services/sweetalert.service';
import { SelectIndicatorsComponent } from 'app/shared/select-indicators/select-indicators.component';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CreateEmployeeComponent } from '../create-employee/create-employee.component';
import { AssignJobComponent } from '../assign-job/assign-job.component';

@Component({
  selector: 'app-employees-table',
  templateUrl: './employees-table.component.html',
  styleUrls: ['./employees-table.component.scss']
})
export class EmployeesTableComponent implements OnInit, OnDestroy {

  employees: InterfaceEmployee[] = [];
  subscriptions: Subscription[] = [];
  showDetail = false;
  selectedEmployee: InterfaceEmployee = {};

  constructor(
    protected employeeService: EmployeeService,
    public modal: NgbModal,
    public swal: SweetalertService
  ) {
  }

  ngOnInit(): void {
    this.resetEmployees();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  getEmployees(): void {
    this.subscriptions.push(
      this.employeeService.getEmployees(false).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
        this.employees = result;
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  searchEmployee(name: string): void {
    if (name.length > 0) {
      this.subscriptions.push(
        this.employeeService.searchEmployee(name, false).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
          this.employees = result;
        }, (error: any) => {
          console.error(error);
        })
      );
    } else {
      this.resetEmployees();
    }
  }

  scrollEmployees(): void {
    this.subscriptions.push(
      this.employeeService.getEmployees(false, [], this.employees[this.employees.length - 1]).pipe(take(1)).subscribe((result: InterfaceEmployee[]) => {
        this.employees = this.employees.concat(result);
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  resetEmployees(): void {
    this.employees = [];
    this.getEmployees();
  }

  addEmployee(): void {
    const modalRef = this.modal.open(CreateEmployeeComponent, {
      centered: true,
      backdrop: "static",
      animation: true,
      size: "lg"
    });
    modalRef.result.then((result: any) => {
      if (result && result.success) {
        this.swal.showSuccess();
      } else if (result && !result.success) {
        this.swal.showError();
      } else {
        this.swal.showCancel();
      }
      this.resetEmployees();
    }).catch((error: any) => {
      console.error(error);
    });
  }

  editIndicators(employee: InterfaceEmployee): void {
    const modalRef = this.modal.open(SelectIndicatorsComponent, {
      centered: true,
      backdrop: "static",
      animation: true,
      size: "lg"
    });
    modalRef.componentInstance.indicatorsIds = employee.indicators;
    modalRef.result.then((result: any) => {
      if (result && result.length > 0) {
        employee.indicators = result;
        this.employeeService.updateEmployee(employee).then(() => {
          this.swal.showSuccess();
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
        });
      }
    }).catch((error: any) => {
      console.error(error);
    });
  }

  viewIndicators(employee: InterfaceEmployee): void {
    this.showDetail = true;
    this.selectedEmployee = employee;
  }

  closeDetail(): void {
    this.showDetail = false;
    this.selectedEmployee = {};
  }

  assignJob(employee: InterfaceEmployee): void {
    const modalRef = this.modal.open(AssignJobComponent, {
      centered: true,
      backdrop: "static",
      animation: true,
      size: "lg"
    });
    modalRef.componentInstance.employee = employee;
    modalRef.result.then((result: any) => {
      if (result && result.length > 0) {
        employee.indicators = result;
        this.employeeService.updateEmployee(employee).then(() => {
          this.swal.showSuccess();
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
        });
      }
    }).catch((error: any) => {
      console.error(error);
    });
  }

}
